import { Nullable } from 'gocclr-shared-ui/dist/helpers';
import { useEffect, useRef } from 'react';
import { getBasePathForMenu } from '../../app-context/accounts-context';
import { PAGES, TARGET } from '../../model/constants';

function AcknowledgementTermsAndConditionsRedirection() {
    const formRef = useRef<Nullable<HTMLFormElement>>(null);
    const basePath = getBasePathForMenu().replace(/\/$/, '');
    const commissionsPath = `${basePath}${PAGES.AGENCY_COMMISSIONS}`;

    useEffect(() => {
        if (formRef.current) {
            formRef.current.submit();
        }
    }, []);

    return (
        <form
            action={commissionsPath}
            target={TARGET.BLANK}
            method="GET"
            ref={formRef}
        />
    );
}

export default AcknowledgementTermsAndConditionsRedirection;